









































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Person extends Vue {
  data(){
    return {
      ...this.$store.state.customer
    }
  }

  formatDate(data){
     var today = new Date(data); 
     var dd: any = today.getDate(); 
     var mm: any = today.getMonth()+1; 
     var yyyy = today.getFullYear(); 
     if(dd<10){dd='0'+dd} 
     if(mm<10){mm='0'+mm} 
     return dd+'.'+mm+'.'+yyyy;
  }
}
